import { Alert } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { selectUserProfile } from "../../features/user/user.selector";
import {
  getPaymentStoreDisplayName,
  isStoreManagedSubscription,
} from "../../helpers";

export const PaymentIssueAlert = () => {
  const user = useAppSelector(selectUserProfile);
  const subscriptionState = user?.subscriptionState;

  if (subscriptionState === "past_due" || subscriptionState === "unpaid") {
    const storeMessage =
      user && isStoreManagedSubscription(user.store)
        ? ` Please update your payment method in ${getPaymentStoreDisplayName(user.store)}.`
        : "";

    return (
      <Alert severity="error">
        Action Required: Update Payment Method Your payment was declined and
        your SellerScout account has been paused.{storeMessage}
      </Alert>
    );
  }
  return null;
};

export default PaymentIssueAlert;
